import React from 'react';
import PublicVenuesHeader from './PublicVenuesHeader';
import { HeroBanner } from './organization/venue-booking/HeroAndCountdown';
import { RealVenuesSection } from './organization/venue-booking/RealVenuesSection';
import { RevenueEstimator } from './organization/venue-booking/RevenueEstimator';
import { FeaturesGrid } from './organization/venue-booking/FeaturesGrid';
import { VenueOwnerCTA } from './organization/venue-booking/VenueOwnerCTA';

export default function VenuesPublicPage() {
  const scrollToVenues = () => {
    document.getElementById('real-venues-section')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="min-h-screen bg-[#0F1829] pt-24" dir="rtl" data-testid="venues-public-page">
      <PublicVenuesHeader />
      <div className="mx-auto max-w-7xl space-y-8 px-4 pb-16 sm:px-6">
        <HeroBanner onCtaClick={scrollToVenues} />

        <RealVenuesSection />

        <VenueOwnerCTA />

        <div className="grid gap-6 lg:grid-cols-2">
          <RevenueEstimator />
          <div className="rounded-2xl border border-white/10 bg-[#1E2D4A] p-6 text-center">
            <p className="text-sm leading-relaxed text-slate-300">
              "منشآت تسيار تزيد دخلها الشهري بأكثر من <span className="font-bold text-teal-300">35%</span> بعد تفعيل الحجز الذكي."
            </p>
            <p className="mt-3 text-xs text-slate-500">— فريق منتج تسيار</p>
          </div>
        </div>

        <FeaturesGrid />
      </div>
    </div>
  );
}
